import React from 'react';
import PropTypes from 'prop-types';

import EntryRow from './entry_row';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class CompReportEntriesTable extends React.Component {
  static propTypes = {
    compReportEntries: PropTypes.array,
    onRemoveEntry: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired
  }

  renderCompEntry = (entry, index) => {
    const { onRemoveEntry, onReorder } = this.props;
    return (
      <EntryRow entry={entry} index={index} key={entry.comp.id} onRemoveEntry={onRemoveEntry} onReorder={onReorder}/>
    );
  }

  render() {
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Property</th>
            <th>Property Type</th>
            <th>Size</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {this.props.compReportEntries.map((entry, index) => this.renderCompEntry(entry, index))}
        </tbody>
      </table>
    );
  }
}

export default reorderableList(CompReportEntriesTable);
